<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-23 20:02:37
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-24 11:48:45
-->
<template>
  <div>
    <div class="header">
      <h3 class="fz-16 yx-pingfang-semibold yx-color-text-primary" :class="[required ? 'required' : '']">{{title}}</h3>
      <p v-if="subTitle" class="mt-8 yx-color-text-regular fz-12">{{subTitle}}</p>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '标题'
    },
    subTitle: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  position: relative;
  padding-left: 11px;
  margin-bottom: 18px;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 3px;
    width: 3px;
    height: 16px;
    background-color: @color-primary;
  }
  h3 {
    display: inline-block;
    position: relative;
    width: fit-content;
    &.required {
      &::after {
        content: '*';
        position: absolute;
        right: -10px;
        top: 0;
        color: red;
      }
    }
  }
}
</style>